import { logout } from 'store/actions/app.actions'
import { store } from 'store/store'

const updateHeaderInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const jwtToken = localStorage.getItem('bearer')
      if (jwtToken) {
        config.headers.Authorization = `${jwtToken}`
      }
      return config
    },
    (error) => {
      Promise.reject(error)
    },
  )

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      switch (error?.response?.status) {
        case 401:
        case 426:
          return store.dispatch(logout())

        default:
          return Promise.reject(error)
      }
    },
  )
}

export default updateHeaderInterceptor
